













import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Group extends Vue {
    @Prop(String) private title!: string;
}
